module.exports = __webpack_public_path__ + "static/media/tnpa-Footer-logo.baf86991.png";